<div class="login-home">
  <div id="loginForm">
    @if(isVersusPay){
      <div class="icon-login">
        <img src="images/versus-white.png"  width="150px;" class="img-fluid mt-4 mb-4"/>
      </div>
      <div class="welcome-message">

        <div class="text-left text-white">
          <h1 class="mb-4">Bienvenue</h1>
          <p>Pret à faire la différence?<br/>Connectez vous et passez à l'action</p>
        </div>
      </div>
      }@else {

    }

    <div >
      <form [formGroup]="loginForm" (ngSubmit)="login()"  class="form-login" >
        @if(!isVersusPay){
          <div class="icon-login"><img src="brand/logo.jpeg" class="img-icon"></div>
        }
        <div class="login-card">
          <div class="form-group">
            <p class="text-danger">{{message}}</p>
          </div>
          <div class="input-group-login">
            <label for="login">Identifiant</label>
            <input name="username" formControlName="username" type="text"  id="login"
              placeholder="Identifiant" required />
          </div>
          <div class="input-group-login">
            <label for="password">Mot de passe</label>
            <div class="password-wrapper">

              <input type="password" name="password" formControlName="password" class="form-control"
                id="password" placeholder="mot de passe" required>
              <span class="password-eye" id="eye" (click)="onShowPassword()">
                @if (!clearPassword) {
                  <i class="fa fa-eye-slash"></i>
                }
                @if (clearPassword) {
                  <i class="fa fa-eye"></i>
                }
              </span>
            </div>


          </div>
          <button class="btn-login" [disabled]="!loginForm.valid">Se
          connecter</button>

          <div class="label-reset">
            <a href="/password/reset"> mot de passe oubli&#233;</a>
          </div>
        </div>
      </form>

    </div>
  </div>

</div>
